// extracted by mini-css-extract-plugin
export default {"container":"lO-z","timeTop":"mO-z","timeCountdown":"nO-z","cta":"oO-z","disabled":"pO-z","product":"qO-z"};